import { SKIN } from '../../types/enums';
import { createSkinComponent } from '../../utils/skinComponent';

import InPlayHeadings from '../../components/organisms/InPlayHeadings';
import TopOfferItem from '../../components/atoms/TopOfferItem';
import SearchEndAdornment from '../../components/atoms/SearchEndAdornment';
import BetslipDrawer from '../../components/organisms/BetslipDrawer';
import HybridLoginForm from '../../components/organisms/HybridLoginForm';
import DefaultFooter from '../../components/molecules/DefaultFooter';
import Header from '../../components/molecules/Header';
import EventsCarousel from '../../components/molecules/EventsCarousel';
import GroupedFeaturedEventsCarousel from '../../components/molecules/grouped-featured/GroupedFeaturedEventsCarousel';
import UserDetailsForm from '../../components/molecules/UserDetailsForm';
import AgentBalance from '../../components/molecules/AgentBalance';
import ReofferedBetslipDrawer from '../../components/organisms/ReofferedBetslipDrawer';
import UserListTabs from '../../components/molecules/UserListTabs';

import GolaInPlayHeadings from '../../components/skins/gola/organisms/InPlayHeadings';
import GolaTopOfferItem from '../../components/skins/gola/atoms/TopOfferItem';
import GolaSearchEndAdornment from '../../components/skins/gola/atoms/SearchEndAdornment';
import GolaBetslipDrawer from '../../components/skins/gola/organisms/BetslipDrawer';
import GolaLoginForm from '../../components/skins/gola/organisms/LoginForm';
import NeobetHybridLoginForm from '../../components/skins/neobet/organisms/HybridLoginForm';
import GolaHeader from '../../components/skins/gola/molecules/Header';
import GolaEventsCarousel from '../../components/skins/gola/molecules/EventsCarousel';
import GolaGroupedFeaturedEventsCarousel from '../../components/skins/gola/molecules/GroupedFeaturedEventsCarousel';
import GolaReofferedBetslipDrawer from '../../components/skins/gola/organisms/ReofferedBetslipDrawer';
import GolaUserDetailsForm from '../../components/skins/gola/molecules/UserDetailsForm';
import GolaAgentBalance from '../../components/skins/gola/molecules/AgentBalance';
import GolaUserListTabs from '../../components/skins/gola/molecules/UserListTabs';
import CreateBOUsersForm from '../../components/organisms/CreateBOUsersForm';
import GolaCreateBOUsersForm from '../../components/skins/gola/organisms/CreateBOUsersForm';
import GolaFooter from '../../components/skins/gola/molecules/Footer';
import NeobetHeader from '../../components/skins/neobet/molecules/Header';
import NeobetFooter from '../../components/skins/neobet/molecules/Footer';
import NeobetBetslipDrawer from '../../components/skins/neobet/organisms/BetslipDrawer';
import NeobetReofferedBetslipDrawer from '../../components/skins/neobet/organisms/ReofferedBetslipDrawer';
import NeobetSearchEndAdornment from '../../components/skins/neobet/atoms/SearchEndAdornment';
import BalanceModal from '../../components/organisms/BalanceModal';
import NeobetBalanceModal from '../../components/skins/neobet/organisms/BalanceModal';
import PaymentProviders from '../../components/atoms/PaymentProviders';
import NeobetPaymentProviders from '../../components/skins/neobet/atoms/PaymentProviders';
import NeobetMobileBottomNav from '../../components/skins/neobet/molecules/MobileBottomNav';
import FormSubmitButton from '../../components/molecules/form-elements/FormSubmitButton';
import NeobetFormSubmitButton from '../../components/skins/neobet/molecules/NeobetFormSubmitButton';

export type MobileBottomNavProps = {
  showSearchEntry: boolean;
  isDrawerOpen: boolean;
  toggleDrawer: () => void;
};

export const SkinnedInPlayHeadings = createSkinComponent(InPlayHeadings, { [SKIN.GOLA]: GolaInPlayHeadings });
export const SkinnedTopOfferItem = createSkinComponent(TopOfferItem, { [SKIN.GOLA]: GolaTopOfferItem });
export const SkinnedSearchEndAdornment = createSkinComponent(SearchEndAdornment, {
  [SKIN.GOLA]: GolaSearchEndAdornment,
  [SKIN.NEOBET]: NeobetSearchEndAdornment,
});

export const SkinnedBetslipDrawer = createSkinComponent(BetslipDrawer, {
  [SKIN.GOLA]: GolaBetslipDrawer,
  [SKIN.NEOBET]: NeobetBetslipDrawer,
});

export const SkinnedHybridLoginForm = createSkinComponent(HybridLoginForm, {
  [SKIN.GOLA]: GolaLoginForm,
  [SKIN.NEOBET]: NeobetHybridLoginForm,
});

export const SkinnedHeader = createSkinComponent(Header, {
  [SKIN.GOLA]: GolaHeader,
  [SKIN.NEOBET]: NeobetHeader,
});

export const SkinnedEventsCarousel = createSkinComponent(EventsCarousel, {
  [SKIN.GOLA]: GolaEventsCarousel,
});

// Neobet renders featured content through its own SportsPage composition (direct import),
// not through GroupedFeaturedContent — so this registry seam intentionally has no neobet adapter.
export const SkinnedGroupedFeaturedEventsCarousel = createSkinComponent(GroupedFeaturedEventsCarousel, {
  [SKIN.GOLA]: GolaGroupedFeaturedEventsCarousel,
});

export const SkinnedUserDetailsForm = createSkinComponent(UserDetailsForm, {
  [SKIN.GOLA]: GolaUserDetailsForm,
});

export const SkinnedAgentBalance = createSkinComponent(AgentBalance, {
  [SKIN.GOLA]: GolaAgentBalance,
});

export const SkinnedReofferedBetslipDrawer = createSkinComponent(ReofferedBetslipDrawer, {
  [SKIN.GOLA]: GolaReofferedBetslipDrawer,
  [SKIN.NEOBET]: NeobetReofferedBetslipDrawer,
});

export const SkinnedCreateBOUsersForm = createSkinComponent(CreateBOUsersForm, {
  [SKIN.GOLA]: GolaCreateBOUsersForm,
});

export const SkinnedUserListTabs = createSkinComponent(UserListTabs, {
  [SKIN.GOLA]: GolaUserListTabs,
});

export const SkinnedFooter = createSkinComponent(DefaultFooter, {
  [SKIN.GOLA]: GolaFooter,
  [SKIN.NEOBET]: NeobetFooter,
});

export const SkinnedAgentFooter = createSkinComponent(null, {
  [SKIN.GOLA]: GolaFooter,
});

export const SkinnedBalanceModal = createSkinComponent(BalanceModal, {
  [SKIN.NEOBET]: NeobetBalanceModal,
});

export const SkinnedPaymentProviders = createSkinComponent(PaymentProviders, {
  [SKIN.NEOBET]: NeobetPaymentProviders,
});

export const SkinnedMobileBottomNav = createSkinComponent<MobileBottomNavProps>(null, {
  [SKIN.NEOBET]: NeobetMobileBottomNav,
});

export const SkinnedFormSubmitButton = createSkinComponent(FormSubmitButton, {
  [SKIN.NEOBET]: NeobetFormSubmitButton,
});
